import { ENV } from '@/lib/config/env';
import {
  DefaultPersonaDto,
  ScopedPersonaDto,
  client as personasClient,
} from '@inference.engine/persona-api-client/web';

import { configureApiClient } from './configure-client';

if (!ENV.PERSONA_API_BASE_URL) {
  throw new Error('PERSONA_API_BASE_URL environment variable is not set');
}

export const personasHttp = configureApiClient(personasClient, ENV.PERSONA_API_BASE_URL);
export type PersonaDto = DefaultPersonaDto | ScopedPersonaDto;
